"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var _axios = _interopRequireDefault(require("axios"));

var Reports = /*#__PURE__*/function () {
  function Reports(client) {
    (0, _classCallCheck2["default"])(this, Reports);
    this.client = client;
    this.resourceUrl = '/report';
  }

  (0, _createClass2["default"])(Reports, [{
    key: "viewReport",
    value: function viewReport(reportType) {
      var _this$client;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var queryString = "?reportType=".concat(encodeURIComponent(reportType));

      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      return (_this$client = this.client).post.apply(_this$client, ["".concat(this.resourceUrl, "/generate-report").concat(queryString), data].concat(args));
    }
  }, {
    key: "exportReport",
    value: function exportReport(reportType) {
      var _this$client2;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var queryString = "?reportType=".concat(encodeURIComponent(reportType));

      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return (_this$client2 = this.client).post.apply(_this$client2, ["".concat(this.resourceUrl, "/export-report").concat(queryString), data].concat(args));
    }
  }, {
    key: "getExportStatus",
    value: function getExportStatus(jobId) {
      var _this$client3;

      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return (_this$client3 = this.client).get.apply(_this$client3, ["".concat(this.resourceUrl, "/export-status/").concat(jobId)].concat(args));
    }
  }, {
    key: "downloadReport",
    value: function downloadReport(jobId) {
      var _this = this;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$asBlob = _ref.asBlob,
          asBlob = _ref$asBlob === void 0 ? false : _ref$asBlob;

      var url = "".concat(this.resourceUrl, "/download/").concat(jobId);

      if (asBlob) {
        return _axios["default"].get("".concat(this.client.baseUrl).concat(url), {
          responseType: 'blob',
          withCredentials: true
        })["catch"](function (error) {
          return _this.client.errorHandle(error);
        });
      }

      return this.client.get(url);
    }
  }, {
    key: "getEntityName",
    value: function getEntityName(entityType) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      return this.client.get("".concat(this.resourceUrl, "?entityType=").concat(entityType), args);
    }
  }, {
    key: "viewCoachingReports",
    value: function viewCoachingReports() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return this.client.get("".concat(this.resourceUrl, "/coaching-reports"), args);
    }
  }]);
  return Reports;
}();

exports["default"] = Reports;